import React from 'react'

export interface HoverPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode | ((isHovered: boolean) => React.ReactNode)
  as?: React.ElementType
  style?: React.CSSProperties
  hoverStyle?: React.CSSProperties
}

export interface RenderProps {
  isHovered: boolean
}

const renderChildren = (
  children: React.ReactNode | ((props: RenderProps) => React.ReactNode),
  isHovered: boolean
) => {
  if (typeof children === 'function') {
    return children({isHovered})
  }

  return children
}

export const SharedHoverPanel = (props: HoverPanelProps) => {
  const {children, as, style, hoverStyle, ...restProps} = props

  const [isHovered, setIsHovered] = React.useState(false)

  const Component = as || 'div'

  return (
    <Component
      {...restProps}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={isHovered ? hoverStyle : style}
    >
      {renderChildren(children, isHovered)}
    </Component>
  )
}
